import Config from '@/config';
import http from './http';

let guaranteeDateRequest = null;
export default {
  getCurrentData: async (login, checkWord) => {
    const response = await http.post(`${Config.apiHost}/pub/user/getCurrentData/`, { login, checkWord });
    return response.data.result;
  },
  updateOldData: async (login, checkWord, user, organization) => {
    const response = await http.post(`${Config.apiHost}/pub/user/updateOldData/`, {
      login, checkWord, user, organization,
    });
    return response.data.result;
  },
  instruction: async () => {
    const response = await http.post(`${Config.apiHost}/pub/content/siteInstruction/`);
    return response.data.result;
  },
  technicalSupport: async () => {
    const response = await http.post(`${Config.apiHost}/pub/content/technicalSupportContacts/`);
    return response.data.result;
  },
  guaranteeDateList: async () => {
    if (!guaranteeDateRequest) {
      guaranteeDateRequest = http.post(`${Config.apiHost}/pub/guaranteeDate/getList/`);
    }
    const response = await guaranteeDateRequest;
    return response.data.result;
  },
};
